export default __webpack_public_path__ + "static/media/j.313ee195.svg";